import { DropdownItemProps } from 'semantic-ui-react';

import { OAuthFlow } from '../../components/types/oauth-client/index';

type OAuthFlowDropwdownItem = DropdownItemProps & {
  value: OAuthFlow;
};

export const SUPPORTED_OAUTH_FLOWS: OAuthFlowDropwdownItem[] = [
  { key: 'CLIENT_CREDENTIALS', value: 'CLIENT_CREDENTIALS', text: 'Client Credentials' },
];
